import { Checkbox } from 'ant-design-vue'
import AgreementTrack from './App'

AgreementTrack.install = (Vue) => {
  Vue.use(Checkbox)
  Vue.component(AgreementTrack.name, AgreementTrack)
}

export default AgreementTrack
